import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SelectModule } from "ng-select";
import { BsDatepickerModule, ModalModule, TooltipModule } from 'ngx-bootstrap';
import { BoxRetalStampsModule } from '../share/boxRetalStamps/boxRetalStamps.module';
import { HistoryBoxModule } from '../history-box/history-box.module';
import { Select2ApiModule } from '../share/select2Api/select2Api.module';
import { BoxRetalStampsTHModule } from '../share/boxRetalStampsTH/boxRetalStampsTH.module';
import { IntegrateLoyaltyComponent } from './integrate-loyalty.component';
import { ConfigLoyaltyComponent } from './config-loyalty/config-loyalty.component';
import {IntegrateLoyaltyV2Module} from '../integrate-loyalty-v2/integrate-loyalty-v2.module';
@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        SelectModule,
        BsDatepickerModule.forRoot(),
        TooltipModule.forRoot(),
        BoxRetalStampsModule,
        HistoryBoxModule,
        Select2ApiModule,
        ModalModule,
        BoxRetalStampsTHModule,
        IntegrateLoyaltyV2Module,

    ],
  declarations: [
    IntegrateLoyaltyComponent,
    ConfigLoyaltyComponent,
  ]
})
export class IntegrateLoyaltyModule { }



// WEBPACK FOOTER //
// /app/src/app/pages/admin/qrcode/integrate-loyalty/integrate-loyalty.module.ts